import { render } from "./ProgramOutcomesDetails.vue?vue&type=template&id=710613a3"
import script from "./ProgramOutcomesDetails.vue?vue&type=script&lang=js"
export * from "./ProgramOutcomesDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__